var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"TVPOWER","name":"TVPOWER","data-vcode":"POWER","disabled":"","aria-label":`${_vm.$t('tvPower')}`}},[_c('img',{attrs:{"src":"/images/icons/tvPower.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('tvPower')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }